// extracted by mini-css-extract-plugin
export default {"statusMessage":"statusMessage-yU4Jv"};